import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {AgGridHeaderComponent} from "../../../../shared/components/ag-grid/ag-grid-header/ag-grid-header.component";
import {AgGridComponentFrameworkComponent} from "../../../../shared/components/ag-grid/ag-grid-component-framework/ag-grid-component-framework.component";
import {CellConversionPathComponent} from "../../../../shared/components/cell-conversion-path/cell-conversion-path.component";
import {AgGridHeaderConversionPathComponent} from "../../../../shared/components/ag-grid/ag-grid-header-conversion-path/ag-grid-header-conversion-path.component";
import {AgGridUtils} from "../../../../shared/libraries/ag-grid-utils";
import {AgGridEvent} from "@ag-grid-community/core";
import {CellValueComponent} from "./cell-value/cell-value.component";
import {ParamsActionsService} from "../../../../shared/services/params-actions.service";
import {ReportStore} from '../../../../shared/store/report/report.store';
import {AdRequestParams} from '../../../../shared/interfaces/ad-reports';
import {Column} from '@ag-grid-enterprise/all-modules';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-path-explorer-report-table',
  templateUrl: './path-explorer-report-table.component.html',
  styleUrls: ['./path-explorer-report-table.component.scss']
})
export class PathExplorerReportTableComponent implements OnInit {
  @Input() public rows: Array<any> = [];
  @Input() public totals: Array<any> = [];
  @Input() public requestParams: Partial<AdRequestParams>;

  public readonly columnDefs: Array<any> = [
    {
      minWidth: 800,
      field: 'conversion_path',
      headerValueGetter: _ => this._translateS.instant('path_explorer.conversion_path'),
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component: CellConversionPathComponent
        };
      },
      headerComponentFramework: AgGridHeaderConversionPathComponent,
      headerComponentParams: {
        onFilterClick: _ => this._paramsActionS.openFilter(),
        filterIsActive: _ => this._paramsActionS.filterIsActive
      },
      resizable: true,
      autoHeight: true
    },
    {
      field: 'conversions',
      filter: 'agNumberColumnFilter',
      headerValueGetter: _ => this._translateS.instant('path_explorer.conversions'),
      headerComponentFramework: AgGridHeaderComponent,
      headerComponentParams: {
        position: 'right'
      },
      valueGetter: row => parseInt(row.data.conversions.value),
      valueFormatter: row => row.data.conversions.formatted,
      percentageGetter: row => row.data.conversions_percentage,
      cellStyle: {'text-align': 'right'},
      resizable: true,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {component: CellValueComponent};
      }
    },
    {
      field: 'revenue',
      filter: 'agNumberColumnFilter',
      headerValueGetter: _ => this._translateS.instant('path_explorer.revenue'),
      headerComponentFramework: AgGridHeaderComponent,
      headerComponentParams: {
        position: 'right'
      },
      valueGetter: row => parseFloat(row.data.revenue.value),
      valueFormatter: row => row.data.revenue.formatted,
      percentageGetter: row => row.data.revenue_percentage,
      cellStyle: {'text-align': 'right'},
      resizable: true,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {component: CellValueComponent};
      }
    }
  ];

  public readonly gridOptions:    any = {
    suppressDragLeaveHidesColumns: true,
    groupHeaderHeight: 35,
    headerHeight: 35
  };

  public readonly defaultColDef:  any = {
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset', 'apply']
    }
  };

  public limit$: Observable<number> = this._reportStore.limit$.pipe(
    map((limit: number) => limit || 25)
  );

  constructor(
    private readonly _reportStore: ReportStore,
    private readonly _translateS: TranslateService,
    private readonly _paramsActionS: ParamsActionsService,
  ) {}

  ngOnInit(): void {}

  public tableDataChanged(event: AgGridEvent): void {
    if (this.requestParams && (event.type === 'firstDataRendered' || event.type === 'rowDataChanged')) {
      if (this.requestParams.tableColumnState) {
        AgGridUtils.columnStateReset(this.requestParams.tableColumnState);
        event.columnApi.applyColumnState({state: this.requestParams.tableColumnState});
        event.api.setFilterModel(this.requestParams.tableFilterModel);
      }
    }
  }

  public tableChanged(event: AgGridEvent): void {
    if (event.type === 'sortChanged' || event.type === 'filterChanged') {
      this._reportStore.updateRequestParamsSubmitted({
        tableColumnState: AgGridUtils.columnStateReset(event.columnApi.getColumnState()),
        tableFilterModel: event.api.getFilterModel()
      });
    }
  }

  public onPaginationPageSizeChanged(limit: number): void {
    this._reportStore.updateLimit(limit);
  }
}
